// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"787d71fb","729":"0ff31dac"}[chunkId] + ".css";
};